import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ea168aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "p-grid p-pt-5"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-col-1" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-spin pi-spinner",
    style: {"font-size":"2rem"}
  })
], -1))
const _hoisted_3 = { class: "p-col-11" }
const _hoisted_4 = { class: "p-grid p-pt-5" }
const _hoisted_5 = { class: "p-col-12" }
const _hoisted_6 = { class: "p-d-flex" }
const _hoisted_7 = { class: "p-col-12 p-mb-2 p-mr-4" }
const _hoisted_8 = { class: "p-d-flex p-flex-column p-flex-md-row" }
const _hoisted_9 = { class: "p-mb-2 p-mr-4 p-ml-2" }
const _hoisted_10 = { class: "p-input-icon-left" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_12 = { class: "p-mb-2 p-mr-4" }
const _hoisted_13 = { class: "p-mb-2 p-mr-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Message = _resolveComponent("Message")!
  const _component_SpecimenLabelPrinter = _resolveComponent("SpecimenLabelPrinter")!
  const _component_Image = _resolveComponent("Image")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$t('loading')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ConfirmPopup),
    _createVNode(_component_DataTable, {
      ref: "RecordTable",
      filters: _ctx.filters,
      "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters) = $event)),
      lazy: true,
      loading: _ctx.loading,
      paginator: true,
      rowHover: true,
      rows: 25,
      rowsPerPageOptions: [10,25,50,100,500,1000],
      totalRecords: _ctx.totalRecords,
      value: _ctx.features,
      currentPageReportTemplate: "{first} - {last} / {totalRecords} Records",
      dataKey: "RECORD_ID",
      filterDisplay: "row",
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
      sortMode: "multiple",
      style: {"min-width":"100% !important"},
      scrollable: true,
      scrollDirection: "both",
      scrollHeight: "600px",
      stripedRows: "",
      onPage: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onPage($event))),
      onSort: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSort($event))),
      resizableColumns: true,
      columnResizeMode: "expand"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('home.my_records')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              (_ctx.headers.length > 0)
                ? (_openBlock(), _createBlock(_component_MultiSelect, {
                    key: 0,
                    class: "p-col-12 p-multiselect-sm",
                    modelValue: _ctx.selectedHeaders,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedHeaders) = $event)),
                    filter: true,
                    optionLabel: "name",
                    placeholder: _ctx.$t('choose_headers'),
                    options: _ctx.allHeaders,
                    display: "chip"
                  }, {
                    option: _withCtx((slotProps) => [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t(slotProps.option.name)), 1)
                      ])
                    ]),
                    chip: _withCtx((slotProps) => [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t(slotProps.value.name)), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder", "options"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_InputText, {
                modelValue: _ctx.filters['global'].value,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters['global'].value) = $event)),
                  _cache[2] || (_cache[2] = ($event: any) => (_ctx.onInput($event)))
                ],
                class: "appTableSearchBar",
                placeholder: _ctx.$t('search_table')
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", null, [
              _createVNode(_component_Button, {
                class: "p-button-success appControlButton",
                icon: "pi pi-plus",
                iconPos: "left",
                onClick: _ctx.toForm,
                label: _ctx.$t('new_record')
              }, null, 8, ["onClick", "label"])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", null, [
              _createVNode(_component_Button, {
                class: "appControlButton",
                icon: "pi pi-download",
                iconPos: "left",
                onClick: _ctx.exportCsv,
                label: _ctx.$t('download')
              }, null, 8, ["onClick", "label"])
            ])
          ])
        ])
      ]),
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('no_records')), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          header: _ctx.$t('edit'),
          class: "editColumn smallTableColumn"
        }, {
          body: _withCtx((slotProps) => [
            (_ctx.editable)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  onClick: ($event: any) => (_ctx.editItem(slotProps.data.RECORD_ID)),
                  class: "button is-small is-link",
                  title: _ctx.$t('edit'),
                  icon: "pi pi-pencil"
                }, null, 8, ["onClick", "title"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["header"]),
        (_ctx.warningComment)
          ? (_openBlock(), _createBlock(_component_Message, {
              key: 0,
              closable: true,
              severity: "warn"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('warning_commentlength')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.state === 'success')
          ? (_openBlock(), _createBlock(_component_Message, {
              key: 1,
              closable: true,
              severity: "success"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('deletion_success')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_Column, {
          header: _ctx.$t('delete'),
          class: "editColumn smallTableColumn"
        }, {
          body: _withCtx((slotProps) => [
            _createVNode(_component_Button, {
              title: _ctx.$t('deleteRecord'),
              class: "p-button-danger p-button-sm",
              icon: "pi pi-trash",
              onClick: _withModifiers(($event: any) => (_ctx.deleteRecord($event, slotProps.data.RECORD_ID)), ["prevent"])
            }, null, 8, ["title", "onClick"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('print'),
          class: "editColumn smallTableColumn"
        }, {
          body: _withCtx((slotProps) => [
            _createVNode(_component_SpecimenLabelPrinter, {
              ref: "SpecimenLabelPrinter",
              tableRow: slotProps.data,
              onWarningComment: _cache[3] || (_cache[3] = ($event: any) => (_ctx.warningComment=true)),
              onClick: ($event: any) => (_ctx.printSpecimenLabel(slotProps.data))
            }, null, 8, ["tableRow", "onClick"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('validationStatus'),
          class: "editColumn smallTableColumn",
          field: "ADM_VALIDATION_STATUS"
        }, {
          body: _withCtx((slotProps) => [
            _createVNode(_component_Button, {
              class: _normalizeClass(["is-small validationBadge", {validated: ['validiert, Bestimmung akzeptiert', 'validiert, Bestimmung angezweifelt, nicht validierbar', 'bereits validiert, neu durch User bearbeitet, nicht mehr zu validieren'].includes(slotProps.data.ADM_VALIDATION_STATUS),
            notYetValidated:  ['bereit zum Validieren', 'bereits validiert, neu durch User bearbeitet, wieder bereit zur Validierung'].includes(slotProps.data.ADM_VALIDATION_STATUS),
            replyByDataCentre: ['validiert, Bestimmung angezweifelt, Rückfrage gestartet'].includes(slotProps.data.ADM_VALIDATION_STATUS)}]),
              icon: "pi pi-flag",
              title: slotProps.data.ADM_VALIDATION_STATUS
            }, null, 8, ["class", "title"])
          ]),
          _: 1
        }, 8, ["header"]),
        (_ctx.showColumn('APP_USER_COMMENT'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 2,
              header: _ctx.$t('table.APP_USER_COMMENT'),
              sortable: true,
              class: "smallTableColumn",
              field: "APP_USER_COMMENT"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        _createVNode(_component_Column, {
          class: "smallTableColumn",
          header: _ctx.$t('table.RECORD_ID'),
          sortable: true,
          field: "RECORD_ID"
        }, null, 8, ["header"]),
        _createVNode(_component_Column, {
          class: "smallTableColumn",
          header: _ctx.$t('table.RECORD_DATE'),
          field: "RECORD_DATE",
          sortable: true
        }, null, 8, ["header"]),
        _createVNode(_component_Column, {
          class: "largeTableColumn",
          header: _ctx.$t('table.TAXON_NAME'),
          field: "TAXON_NAME",
          sortable: true
        }, null, 8, ["header"]),
        (_ctx.showColumn('IF_FLORAPP_REFERENCE_WORK'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 3,
              header: _ctx.$t('table.IF_FLORAPP_REFERENCE_WORK'),
              class: "smallTableColumn",
              field: "IF_FLORAPP_REFERENCE_WORK",
              sortable: true
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('X'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 4,
              header: _ctx.$t('table.X'),
              sortable: true,
              class: "smallTableColumn",
              field: "X"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('Y'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 5,
              header: _ctx.$t('table.Y'),
              sortable: true,
              class: "smallTableColumn",
              field: "Y"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('PRECISION_XY'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 6,
              header: _ctx.$t('table.PRECISION_XY'),
              sortable: true,
              class: "smallTableColumn",
              field: "PRECISION_XY"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('Z_MEASURED'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 7,
              header: _ctx.$t('table.Z_MEASURED'),
              sortable: true,
              class: "smallTableColumn",
              field: "Z_MEASURED"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('CERTAINTY'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 8,
              header: _ctx.$t('table.CERTAINTY'),
              sortable: true,
              class: "smallTableColumn",
              field: "CERTAINTY"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('DETERMINATION_TYPE'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 9,
              header: _ctx.$t('table.DETERMINATION_TYPE'),
              sortable: true,
              class: "smallTableColumn",
              field: "DETERMINATION_TYPE"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('LEG'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 10,
              header: _ctx.$t('table.LEG'),
              sortable: true,
              class: "smallTableColumn",
              field: "LEG"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('DET'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 11,
              header: _ctx.$t('table.DET'),
              sortable: true,
              class: "smallTableColumn",
              field: "DET"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('VIS'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 12,
              header: _ctx.$t('table.VIS'),
              sortable: true,
              class: "smallTableColumn",
              field: "VIS"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('REPORTER'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 13,
              header: _ctx.$t('table.REPORTER'),
              sortable: true,
              class: "smallTableColumn",
              field: "REPORTER"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('SUBSTRATE_COARSE'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 14,
              header: _ctx.$t('table.SUBSTRATE_COARSE'),
              sortable: true,
              class: "smallTableColumn",
              field: "SUBSTRATE_COARSE"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('SUBSTRATE_FINE'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 15,
              header: _ctx.$t('table.SUBSTRATE_FINE'),
              sortable: true,
              class: "smallTableColumn",
              field: "SUBSTRATE_FINE"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('WOODY_PLANT'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 16,
              header: _ctx.$t('table.WOODY_PLANT'),
              sortable: true,
              class: "smallTableColumn",
              field: "WOODY_PLANT"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('FRUITBODY'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 17,
              header: _ctx.$t('table.FRUITBODY'),
              sortable: true,
              class: "smallTableColumn",
              field: "FRUITBODY"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('WOOD_DEGRADATION'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 18,
              header: _ctx.$t('table.WOOD_DEGRADATION'),
              sortable: true,
              class: "smallTableColumn",
              field: "WOOD_DEGRADATION"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('WOOD_QUALITY'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 19,
              header: _ctx.$t('table.WOOD_QUALITY'),
              sortable: true,
              class: "smallTableColumn",
              field: "WOOD_QUALITY"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('SPORE_TYPE_RUSTS'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 20,
              header: _ctx.$t('table.SPORE_TYPE_RUSTS'),
              sortable: true,
              class: "smallTableColumn",
              field: "SPORE_TYPE_RUSTS"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('SEXUAL_STAGE'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 21,
              header: _ctx.$t('table.SEXUAL_STAGE'),
              sortable: true,
              class: "smallTableColumn",
              field: "SEXUAL_STAGE"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('HOST_PLANT'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 22,
              header: _ctx.$t('table.HOST_PLANT'),
              sortable: true,
              class: "smallTableColumn",
              field: "HOST_PLANT"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('HOST_FUNGUS'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 23,
              header: _ctx.$t('table.HOST_FUNGUS'),
              sortable: true,
              class: "smallTableColumn",
              field: "HOST_FUNGUS"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('HOST_LICHEN'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 24,
              header: _ctx.$t('table.HOST_LICHEN'),
              sortable: true,
              class: "smallTableColumn",
              field: "HOST_LICHEN"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('PROJECT'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 25,
              header: _ctx.$t('table.PROJECT'),
              sortable: true,
              class: "smallTableColumn",
              field: "PROJECT"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('LITERATURE'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 26,
              header: _ctx.$t('table.LITERATURE'),
              sortable: true,
              class: "smallTableColumn",
              field: "LITERATURE"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('PUBLICATION'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 27,
              header: _ctx.$t('table.PUBLICATION'),
              sortable: true,
              class: "smallTableColumn",
              field: "PUBLICATION"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('SPECIMEN_LABEL'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 28,
              header: _ctx.$t('table.SPECIMEN_LABEL'),
              sortable: true,
              class: "smallTableColumn",
              field: "SPECIMEN_LABEL"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('LOCALITY_DESCRIPTION'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 29,
              header: _ctx.$t('table.LOCALITY_DESCRIPTION'),
              sortable: true,
              class: "smallTableColumn",
              field: "LOCALITY_DESCRIPTION"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('DELARZE_HABITAT'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 30,
              header: _ctx.$t('table.DELARZE_HABITAT'),
              sortable: true,
              class: "smallTableColumn",
              field: "DELARZE_HABITAT"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('FLORAPP_VEGETATION_SURVEY'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 31,
              header: _ctx.$t('table.FLORAPP_VEGETATION_SURVEY'),
              sortable: true,
              class: "smallTableColumn",
              field: "FLORAPP_VEGETATION_SURVEY"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('COMMENT_RECORD'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 32,
              header: _ctx.$t('table.COMMENT_RECORD'),
              sortable: true,
              class: "smallTableColumn",
              field: "COMMENT_RECORD"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('COMMENT_SITE'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 33,
              header: _ctx.$t('table.COMMENT_SITE'),
              sortable: true,
              class: "smallTableColumn",
              field: "COMMENT_SITE"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('SUGGESTED_TAXON_NAME'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 34,
              class: "smallTableColumn",
              field: "SUGGESTED_TAXON_NAME",
              header: _ctx.$t('table.SUGGESTED_TAXON_NAME'),
              sortable: true
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('SUGGESTED_TAXON_DESCRIPTION'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 35,
              class: "smallTableColumn",
              field: "SUGGESTED_TAXON_DESCRIPTION",
              header: _ctx.$t('table.SUGGESTED_TAXON_DESCRIPTION'),
              sortable: true
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('SUGGESTED_TAXON_PUBLICATION'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 36,
              class: "smallTableColumn",
              field: "SUGGESTED_TAXON_PUBLICATION",
              header: _ctx.$t('table.SUGGESTED_TAXON_PUBLICATION'),
              sortable: true
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('SUGGESTED_TAXON_COMMENT'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 37,
              class: "smallTableColumn",
              field: "SUGGESTED_TAXON_COMMENT",
              header: _ctx.$t('table.SUGGESTED_TAXON_COMMENT'),
              sortable: true
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('PRESENCE'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 38,
              header: _ctx.$t('table.PRESENCE'),
              sortable: true,
              class: "smallTableColumn",
              field: "PRESENCE"
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('LAST_EDITED_BY'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 39,
              header: _ctx.$t('table.LAST_EDITED_BY'),
              class: "smallTableColumn",
              field: "LAST_EDITED_BY",
              sortable: true
            }, null, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.showColumn('IMAGE'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 40,
              header: _ctx.$t('table.IMAGE'),
              class: "smallTableColumn",
              field: "IMAGE"
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.IMAGE)
                  ? (_openBlock(), _createBlock(_component_Image, {
                      key: 0,
                      src: slotProps.data.IMAGE,
                      imageClass: "app-image"
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["filters", "loading", "totalRecords", "value"])
  ], 64))
}